/*
 * @Author: YuanYuan
 * @Date: 2024-05-06 15:14:04
 * @LastEditTime: 2025-12-18 09:41:34
 * @Description: 通用接口集合
 */
const prefix = process.env.VUE_APP_API_PREFIX

export default [

  {
    name: 'waapDict',
    path: `${prefix}/dict/getCodeList`,
    method: 'post',
    params: {
      codeList: [],
      consoleCode: ''
    },
    desc: 'waap字典'
  },
  {
    name: 'getSelectOptions',
    path: `${prefix}/dict/select`,
    method: 'get',
    params: {
      type:''
    },
    desc: '下拉框数据'
  },
  {
    name: 'areaDict',
    path: `${prefix}/dict/getAreaInfo`,
    method: 'get',
    params: {},
    desc: '地区字典'
  },
  {
    name: 'waapPreActList',
    path: `${prefix}/shareAction/getPredefineActList`,
    method: 'post',
    params: {
      functionalItem: ''
    },
    desc: 'waap预置动作列表'
  },
  {
    name: 'waapActList',
    path: `${prefix}/shareAction/getActList`,
    method: 'post',
    params: {
      functionalItem: ''
    },
    desc: 'waap动作列表'
  },
  {
    name: 'waapAuthPolicyTypes',
    path: `${prefix}/serviceControl/getAuthPolicyTypeList`,
    method: 'get',
    params: {},
    desc: 'waap权限管控'
  },
  {
    name: 'productList',
    path: `${prefix}/product/list`,
    method: 'get',
    params: {},
    desc: '产品相关-获取所有产品类型(合并csec2.0中的 window.productName, window.productNameList -> isParam为true), window.productConfig -> switch为1'
  },
  {
    name: 'transferClient',
    path: `${prefix}/user/transClient`,
    method: 'get',
    params: {
      transToConsumerName: ''
    },
    desc: '切换渠道商客户'
  },
  {
    name: 'attributes',
    path: `${prefix}/user/getAttribute`,
    method: 'get',
    params: {},
    desc: '获取登录信息'
  },
  {
    name: 'menus',
    path: `${prefix}/permission/getCurrent`,
    method: 'get',
    params: {
      platform: 1
    },
    desc: '获取左侧菜单',
    // mock: {
    //   code: 200,
    //   data: {
    //     trees: [{
    //       code: 'Configurations',
    //       nameCn: '你先别管我',
    //       nameEn: '你先别管我',
    //       children: [
    //         { nameCn: '网站接入换成域名管理', nameEn: '网站接入换成域名管理', url: '/websiteSettings' },
    //         { nameCn: '域名管理', nameEn: '域名管理', url: '/domainManage' },
    //         { nameCn: '四层代理', nameEn: '四层代理', url: '/l4Proxy' },
    //         {
    //           nameCn: '分析与日志',
    //           nameEn: '分析与日志',
    //           children: [
    //             { nameCn: '流量分析', nameEn: '流量分析', url: '/trafficAnalysis' }
    //           ]
    //         },
    //         {
    //           nameCn: '工具与服务',
    //           nameEn: '工具与服务',
    //           children: [
    //             { nameCn: '证书管理', nameEn: '证书管理', url: '/certificates' },
    //             { nameCn: '缓存刷新', nameEn: '缓存刷新', url: '/tasks' },
    //             { nameCn: '域名组管理', nameEn: '域名组管理', url: '/groups' },
    //           ]
    //         },
    //         {
    //           nameCn: '计费管理',
    //           nameEn: '计费管理',
    //           children: [
    //             { nameCn: '用量查询', nameEn: '用量查询', url: '/usage' },
    //             { nameCn: '套餐管理', nameEn: '套餐管理', url: '/packages' }
    //           ]
    //         }
    //       ]
    //     }, {
    //       code: 'Bills',
    //       nameCn: '费用',
    //       nameEn: '费用',
    //       children: [
    //         { nameCn: '账户总览', nameEn: '账户总览', url: '/account' },
    //         { nameCn: '我的订单', nameEn: '我的订单', url: '/orders' },
    //         { nameCn: '收支记录', nameEn: '收支记录', url: '/transactions' }
    //       ]
    //     }, {
    //       code: 'User',
    //       nameCn: '账号信息管理',
    //       nameEn: '账号信息管理',
    //       children: [
    //         { nameCn: '基本信息', nameEn: '基本信息', url: '/baseInfo' },
    //         { nameCn: '安全设置', nameEn: '安全设置', url: '/securitySet' },
    //         { nameCn: '通知设置', nameEn: '通知设置', url: '/noteSet' }
    //       ]
    //     }, {
    //       code: 'DomainMngmt',
    //       nameCn: '你先别管',
    //       nameEn: '你先别管',
    //       children: [
    //         { nameCn: '域名配置', nameEn: 'Domain Config', url: '/domainManage/singleDomain/domainConfig' },
    //         { nameCn: '加速配置', nameEn: 'Acceleration Config', url: '/domainManage/singleDomain/accelerationConfig' }
    //       ]
    //     }, {
    //       code: 'Distributor',
    //       nameCn: '渠道管理',
    //       nameEn: '渠道管理',
    //       children: [
    //         { nameCn: '概览', nameEn: '概览', url: '/distributor/overview' },
    //         { nameCn: '渠道商信息管理', nameEn: '渠道商信息管理', url: '/distributor/info' },
    //         { nameCn: '客户管理', nameEn: '客户管理', url: '/distributor/customers' },
    //         { nameCn: '客户订单', nameEn: '客户订单', url: '/distributor/orders' },
    //       ]
    //     }]
    //   }
    // }
  }
]
